import { ASSETS } from "@/lib/assets";
import { StoreBadges } from "@/components/landing/StoreBadges";

export const Download = () => (
  <section id="download" className="px-6 pb-24 lg:pb-32">
    <div className="relative mx-auto max-w-6xl overflow-hidden rounded-[2.5rem] bg-[var(--olive-deep)] px-8 py-16 text-center sm:px-16 lg:py-24">
      <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-[var(--olive)] opacity-40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-[var(--sage)] opacity-30 blur-3xl" />

      <div className="relative">
        <img
          src={ASSETS.logo}
          alt="Domaya logo"
          className="mx-auto h-16 w-16 rounded-2xl object-cover shadow-lg"
        />
        <h2
          data-testid="download-heading"
          className="mx-auto mt-8 max-w-2xl font-display text-4xl font-semibold leading-tight tracking-tight text-[var(--cream)] sm:text-5xl"
        >
          Bring a little calm home.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-[#cfd8bd]">
          Domaya is launching soon on iOS and Android. Keep an eye on this page —
          the download buttons will go live the moment we do.
        </p>
        <div className="mt-10 flex justify-center">
          <StoreBadges align="center" />
        </div>
      </div>
    </div>
  </section>
);
